import { Component } from 'react';

export function debounceFn(fn, delay, before) {
  let timeout, args, that;
  function debounceFn() {
    that = this;
    args = arguments;
    clearTimeout(timeout);
    if (before) before.apply(that, args);
    timeout = setTimeout(function() {
      fn.apply(that, args);
      args = false;
    }, delay);
  }

  function execute() {
    if (args) {
      clearTimeout(timeout);
      fn.apply(that, args);
      args = false;
    }
  }

  debounceFn.execute = execute;

  return debounceFn;
}



export function debounce(delay: Number, onTrigger?: (...args: any) => void) {
  return function(target, key, descriptor) {
    if (descriptor === undefined) {
      descriptor = Object.getOwnPropertyDescriptor(target, key);
    }
    descriptor.value = debounceFn(descriptor.value, delay, onTrigger);

    if (target instanceof Component) {
      let oldUnmount = target.componentWillUnmount;
      target.componentWillUnmount = function() {
        descriptor.value.execute();
        if (oldUnmount) oldUnmount.call(this);
      };
    }

    return descriptor;
  };
}
